import { AdTile } from './AdTile/AdTile.js';
import { ApplicationForm } from './ApplicationForm/ApplicationForm.js';
import { BankAccountFiltration } from './BankAccountFiltration/BankAccountFiltration.js';
import { BenefitsBlock } from './BenefitsBlock/BenefitsBlock.js';
import { BonusBenefitsBlock } from './BonusBenefitsBlock/BonusBenefitsBlock.js';
import { ButtonsBlock } from './ButtonsBlock/ButtonsBlock.js';
import { CalculatorBonus } from './CalculatorBonus/CalculatorBonus.js';
import { CalculatorBusinessDeposit } from './CalculatorBusinessDeposit/CalculatorBusinessDeposit.js';
import { CalculatorCredit } from './CalculatorCredit/CalculatorCredit.js';
import { CalculatorDeposit } from './CalculatorDeposit/CalculatorDeposit.js';
import { CalculatorRefinancing } from './CalculatorRefinancing/CalculatorRefinancing.js';
import { CardTransfer } from './CardTransfer/CardTransfer.js';
import { Carousel } from './Carousel/Carousel.js';
import { CarouselCard } from './CarouselCard/CarouselCard.js';
import { CarouselCatalogCard } from './CarouselCatalogCard/CarouselCatalogCard.js';
import { CarouselLinks } from './CarouselLinks/CarouselLinks.js';
import { CarouselRecommendationCard } from './CarouselRecommendationCard/CarouselRecommendationCard.js';
import { CarouselTariffsCard } from './CarouselTariffsCard/CarouselTariffsCard.js';
import { ContactsBlock } from './ContactsBlock/ContactsBlock.js';
import { DepositFiltration } from './DepositFiltration/DepositFiltration.js';
import { Depository } from './Depository/Depository.js';
import { ErrorBlock } from './ErrorBlock/ErrorBlock.js';
import { ExchangeRateTile } from './ExchangeRateTile/ExchangeRateTile.js';
import { Footer } from './Footer/Footer.js';
import { GracePeriod } from './GracePeriod/GracePeriod.js';
import { GrantSupport } from './GrantSupport/GrantSupport.js';
import { Header } from './Header/Header.js';
import { Headline } from './Headline/Headline.js';
import { HorizontalLayout } from './HorizontalLayout/HorizontalLayout.js';
import { ImgBlock } from './ImgBlock/ImgBlock.js';
import { InsuranceAmountBlock } from './InsuranceAmountBlock/InsuranceAmountBlock.js';
import { InvestmentInfo } from './InvestmentInfo/InvestmentInfo.js';
import { LinkDocs } from './LinkDocs/LinkDocs.js';
import { MobileAppTile } from './MobileAppTile/MobileAppTile.js';
import { MortgageFiltration } from './MortgageFiltration/MortgageFiltration.js';
import { OfficesAtmsMap } from './OfficesAtmsMap/OfficesAtmsMap.js';
import { Placeholder } from './Placeholder/Placeholder.js';
import { ProductBlock } from './ProductBlock/ProductBlock.js';
import { ProductGallery } from './ProductGallery/ProductGallery.js';
import { RepresentativeOfficeInfo } from './RepresentativeOfficeInfo/RepresentativeOfficeInfo.js';
import { RichTextBlock } from './RichTextBlock/RichTextBlock.js';
import { RollupItem } from './RollupItem/RollupItem.js';
import { SafeDepositRental } from './SafeDepositRental/SafeDepositRental.js';
import { StepsBlock } from './StepsBlock/StepsBlock.js';
import { StickyBottomMenu } from './StickyBottomMenu/StickyBottomMenu.js';
import { TabsLayout } from './TabsLayout/TabsLayout.js';
import { TariffsTable } from './TariffsTable/TariffsTable.js';
import { TextBlock } from './TextBlock/TextBlock.js';
import { UnitBlock } from './UnitBlock/UnitBlock.js';
import { VerticalLayout } from './VerticalLayout/VerticalLayout.js';
import { Video } from './Video/Video.js';
export const Blocks = {
    AdTile,
    ApplicationForm,
    BankAccountFiltration,
    BenefitsBlock,
    BonusBenefitsBlock,
    ButtonsBlock,
    CalculatorBonus,
    CalculatorBusinessDeposit,
    CalculatorCredit,
    CalculatorDeposit,
    CalculatorRefinancing,
    CardTransfer,
    Carousel,
    CarouselCard,
    CarouselCatalogCard,
    CarouselLinks,
    CarouselRecommendationCard,
    CarouselTariffsCard,
    ContactsBlock,
    DepositFiltration,
    Depository,
    ErrorBlock,
    ExchangeRateTile,
    Footer,
    GracePeriod,
    GrantSupport,
    Header,
    Headline,
    HorizontalLayout,
    ImgBlock,
    InsuranceAmountBlock,
    InvestmentInfo,
    LinkDocs,
    MobileAppTile,
    MortgageFiltration,
    OfficesAtmsMap,
    Placeholder,
    ProductBlock,
    ProductGallery,
    RepresentativeOfficeInfo,
    RichTextBlock,
    RollupItem,
    SafeDepositRental,
    StepsBlock,
    StickyBottomMenu,
    TabsLayout,
    TariffsTable,
    TextBlock,
    UnitBlock,
    VerticalLayout,
    Video,
};
//# sourceMappingURL=Blocks.js.map